export const DEFAULT_USER_NAME = 'antd-landing-user-name';

// leancloud
export const DEFAULT_FILE_NAME = 'Edit';
export const DEFAULT_USER_AV_NAME = 'EditUser';

export const DEFAULT_TEMPLATE_DATA = {
  template: [
    'Banner6_0',
    'Feature9_0',
    'Feature10_0',
    'Feature11_0',
    'Feature13_0',
    'Feature14_0',
    'Feature15_0',
    'Feature12_0',
    'Feature16_0',
    'Feature98_0',
    'Pricing3_0',
    'Footer3_0',
  ],
  // template: [
  //   'Nav0_0', 'Banner0_0', 'Content0_0',
  //   'Content1_0', 'Content3_0', 'Footer0_0',
  // ],
  config: {},
  style: [],
  other: {},
  page: {},
};
